<template>
  <div class="about-us">
    <Scrollama @step-enter="stepEnterHandler">
      <div class=" step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation">{{textData.title}}</div>
          <div class="content animation">{{textData.describe}}</div>
<!--          <div class="btn animation">查看更多</div>-->
        </div>
      </div>
      <div class=" step2" data-step="b">
        <div class="partners">
          <div class="first-level-title animation" v-show="show1">
            {{partnerData1.t1}}
          </div>
          <div class="content animation text" v-show="show1">
            {{partnerData1.t1c}}
          </div>
          <div class="icon animation" v-show="show1">
            <div></div>
          </div>
        </div>
      </div>
      <div class=" step3" data-step="c">
        <div class="partner bg-img-maintain">
          <div class="first-level-title animation" v-show="show2">
            {{partnerData1.t2}}
          </div>
          <div class="content">
            <div class="item animation bg-img-maintain" :key="index" v-for="(item, index) in partnerTypeList" v-show="show2">
              <div class="secondary-title">{{ item.title }}</div>
              <div class="text">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" step4" data-step="d">
        <div class="collaborative-support">
          <div class="first-level-title animation" v-show="show3">{{partnerData1.t3}}</div>
          <div class="tag animation" v-show="show3">
            <div class="tag-item" v-for="(item,index) in partnerTopList" :key="index">
              <img :src="item.img" alt="">
              <div class="secondary-title title2">{{ item.title }}</div>
            </div>
          </div>
          <div class="content animation" v-show="show3">
            <div class="item  bg-img-maintain" v-for="(item,index) in partnerBottomList" :key="index">
              <div class="heading">
                {{ item.tab }}
              </div>
              <div v-for="(item2,index2) in 4" :key="index2">
                <div class="mg secondary-title">{{item['content' + item2]}}</div>
                <div class="mg text">{{item['describe' + item2]}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" step5" data-step="e">
        <div class="support">
          <div class="first-level-title animation" v-show="show4">{{partnerData1.t4}}</div>
          <div class="content animation" v-show="show4">
            <div class="item item1  bg-img-maintain" :style="{ backgroundImage: `url(${item.img})`}" v-for="(item,index) in supportList" :key="index">
              <div class="secondary-title">{{ item.tab }}</div>
              <div class="txt text">{{ item.describe }}</div>
            </div>
          </div>
        </div>
      </div>
    </Scrollama>
    <footer-item></footer-item>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../home/components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      partnerTypeList: [],
      partnerTopList: [],
      partnerBottomList: [],
      supportList: [],
      textData: {},
      partnerData1: {}
    }
  },
  methods: {
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
      }
    }
  },
  mounted: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page501.g501[2]
      this.partnerData1 = this.$boss.page570.g570[0]
      this.partnerTypeList = this.$boss.page571.g571
      this.partnerTopList = this.$boss.page272.g272.reverse()
      this.partnerBottomList = this.$boss.page273.g273
      this.supportList = this.$boss.page274.g274.reverse()
      // this.content2 = this.$boss.page612.g612[0]
    }
  }
}
</script>
<style scoped lang="less">
  .about-us {
    width: 100%;
    height: 100%;

    font-weight: '微软雅黑';
    overflow-x: hidden;
    div {
      //一级标题
      .first-level-title {
        font-size: 32px;
        font-weight: bold;
        color: #323232;
      }

      //二级标题
      .secondary-title {
        font-size: 24px;
        font-weight: 500;
        color: #323232;
      }

      //正文
      .text {
        font-size: 20px;
        color: #323232;
        margin-top: 70px;
      }

      //背景图宽度保持不变类
      .bg-img-maintain {
        background-size: cover !important;
        background-position: center !important;
      }

      .head {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        height: 71vh;
        img {
          width: 100%;
          height: 100%;
        }
        .title {
          font-size: 52px;
          opacity: 0;
          margin-top: -45vh;
          font-weight: bold;
          color: #fff;
          padding-left: 100px;
        }

        .content {
          padding-left: 100px;
          font-size: 32px;
          opacity: 0;
          margin-top: 40px;
          color: #E6E9F3;
        }

        .btn {
          font-size: 22px;
          margin-top: 110px;
          width: 215px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          color: transparent;
          border: 1px solid transparent;
          margin-bottom: 110px;
        }

      }

      .partners {
        border: 1px solid rgba(0, 0, 0, 0);
        width: 100%;
        height: 524px;
        padding: 100px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .content {
          width: 968px;
        }

        .icon {
          display: flex;
          justify-content: center;
          margin-top: 70px;

          div {
            width: 60px;
            height: 80px;
            background: url("../../../static/images/aboutUs/partners/downarrow.png") no-repeat;
          }
        }
      }

      .partner {
        border: 1px solid rgba(0, 0, 0, 0);
        width: 100%;
        height: 580px;
        padding: 100px 100px;
        background-color: #F2F6FF;
        box-sizing: border-box;
        background: url("../../../static/images/aboutUs/partners/partnertype.png") no-repeat;

        .content {
          margin-top: 70px;
          display: flex;
          justify-content: space-between;

          .item {
            background: url("../../../static/images/aboutUs/partners/partner1.png") no-repeat;
            height: 275px;
            width: 41%;
            padding: 70px 50px;
            text-align: left;
            border-radius: 3%;
            animation: comeOut2 0.8s forwards;

            .text {
              margin-top: 30px;
            }
          }

          .item:hover //hover用于选择鼠标指针浮动在上面的元素
          {
            animation: goBack2 0.8s forwards;
          }
        }
      }

      .collaborative-support {
        padding: 100px 100px 0 100px;

        .tag {
          display: flex;
          width: 100%;
          justify-content: space-around;
          margin-top: 70px;

          .tag-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            animation: comeOut 0.5s forwards;

            img {
              width: 86px;
              height: 84px;
            }

            .title2 {
              margin-top: 30px;
            }
          }

          .tag-item:hover //hover用于选择鼠标指针浮动在上面的元素
          {
            animation: goBack 0.5s forwards;
          }
        }

        .content {
          display: flex;
          justify-content: space-between;
          margin-top: 70px;

          .item {
            width: 48%;
            height: 719px;
            background: url("../../../static/images/aboutUs/partners/partnerbg.png") no-repeat;
            text-align: left;

            .heading {
              margin-top: 50px;
              font-size: 32px;
              font-weight: bold;
              margin-top: 30px;
              width: 288px;
              height: 90px;
              line-height: 90px;
              padding-left: 50px;
              color: #fff;
              background: url("../../../static/images/aboutUs/partners/ask.png") no-repeat;
            }

            .title2 {
              margin-top: 50px;
              margin-top: 30px;
            }

            .mg {
              margin-top: 30px;
              margin-left: 50px;
            }
          }
        }
      }

      .support {
        height: 670px;
        padding: 100px 100px;

        .content {
          margin-top: 70px;
          display: flex;
          justify-content: space-between;

          .item1 {
            background: url("../../../static/images/aboutUs/partners/support1.png") no-repeat;
          }

          .item2 {
            background: url("../../../static/images/aboutUs/partners/support2.png") no-repeat;
          }

          .item3 {
            background: url("../../../static/images/aboutUs/partners/support3.png") no-repeat;
          }

          .item4 {
            background: url("../../../static/images/aboutUs/partners/support4.png") no-repeat;
          }

          .item {
            height: 490px;
            width: 24%;
            box-sizing: border-box;
            padding: 50px;
            text-align: left;

            .title2 {
              font-size: 24px;
              font-weight: bold;
            }

            .txt {
              margin-top: 30px;
            }
          }
        }
      }
    }
  }

  @keyframes goBack {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-20%);
    }
  }

  @keyframes comeOut {
    0% {
      transform: translateY(-20%);
    }
    100% {
      transform: translateY(0);
    }
  }

  @keyframes goBack2 {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10%);
    }
  }

  @keyframes comeOut2 {
    0% {
      transform: translateY(-10%);
    }
    100% {
      transform: translateY(0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/partners/partners.vue